<template>
	<div v-if="firstVerifiedCheck" style="height: 100%;">
		<login v-if="!isLoggedIn"/>
		<not-verified v-else-if="!isVerified"/>
		<company-chooser v-else-if="!transporterCode"/>
		<keep-alive>
			<slot v-if="accessRequirementsMet" />
		</keep-alive>
	</div>
	<div v-else>
		Initializing
	</div>
</template>

<script>
import Login from './login.vue';
import NotVerified from './notVerified.vue';
import CompanyChooser from './companyChooser.vue';

import {
	mapState, mapMutations, mapActions
} from './store/login.store.js';

import { userAuth } from '@/core';
/**
 * Made a method which is a setter instead of static values
 */
export default {
	name: 'accessRequirements',
	components: {
		Login,
		NotVerified,
		CompanyChooser
	},
	data() {
		return { firstVerifiedCheck: false };
	},
	computed: {
		...mapState([
			'transporterCode',
			'isLoggedIn',
			'isVerified',
			'isSuper',
		]),
		accessRequirementsMet() {
			return Boolean(this.isLoggedIn) && Boolean(this.isVerified) && Boolean(this.transporterCode);
		}
	},
	watch: {
		isLoggedIn() {
			this.setFirstVerifiedCheck();
			this.refreshAccess();
		},
		isVerified() {
			this.setFirstVerifiedCheck();
			this.refreshAccess();
		},
		transporterCode() {
			this.setFirstVerifiedCheck();
			this.refreshAccess();
		},
	},
	mounted() {
		this.setFirstVerifiedCheck();
		this.refreshAccess();
	},
	methods: {
		...mapActions(['userLastLogin']),
		...mapMutations([
			'setLoggedIn',
			'setIsVerified',
			'setIsSuper',
		]),
		async refreshAccess() {
			try {
				let {
					notLoggedIn,
					notVerified,
					superUser
				} = await userAuth.verifyUserHasAccess();
				this.setLoggedIn(!notLoggedIn);
				this.setIsVerified(!notVerified);
				this.setIsSuper(superUser);
				if (this.accessRequirementsMet) {
					this.userLastLogin();
				}
			} catch (err) {
				// missing
			} finally {
				this.setFirstVerifiedCheck(true);
			}
		},
		setFirstVerifiedCheck(value = false) {
			this.firstVerifiedCheck = value;
		}
	},
};
</script>

